import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatIconModule} from "@angular/material/icon";
import {MatButtonModule} from "@angular/material/button";
import {MatTabsModule} from '@angular/material/tabs';
import {MatTable, MatTableDataSource, MatTableModule} from '@angular/material/table';
import {Appointment} from "@allaihealth/util";
import {PatientsService} from "../../../../services/patients/patients-service";
import {Router} from "@angular/router";
import {OrgDatePipe} from "../../../../lib/org-date.pipe";

/** The survey answer page */
@Component({
	selector: 'app-patient-appointments',
	imports: [
		MatIconModule,
		MatButtonModule,
		MatTabsModule,
		MatTableModule,
		OrgDatePipe
	],
	templateUrl: './patient-appointments.component.html',
	styleUrl: './patient-appointments.component.scss'
})
export class PatientAppointmentsComponent implements OnInit, OnDestroy {

	dataSource:MatTableDataSource<Appointment>;

	readonly displayedColumns:(keyof Appointment)[] = ['id', 'id_patient_survey_link', 'appointment_date', 'ehr_appointment_type_name'];

	/** Table on the page showing the organization */
	@ViewChild(MatTable)
	private table:MatTable<Appointment>;

	constructor(private patientsService:PatientsService, private router:Router) {
	}

	ngOnInit() {
		this.dataSource = new MatTableDataSource<Appointment>(this.patientsService.patientDetail.appointments ?? []);
		this.table?.renderRows();
	}

	ngOnDestroy() {
	}

	async gotoAppointment(appointment:Appointment) {
		const url = this.router.serializeUrl(this.router.createUrlTree(['/', 'appointments', appointment.id]));
		window.open(url, `_appointment_${appointment.id}`);
	}

	formatDate(date: string): string {
		return new Date(date).toLocaleString();
	}

}
